const displayUnitPrice = () => {
	const lineItemElement = document.querySelector('.cart-drawer .line-item ');
	if (!lineItemElement) return;

	const lineItemUnitPriceElement = lineItemElement.querySelector('.line-item [data-js-line-item-unit-price]');
	const lineItemPriceElement = Number(lineItemUnitPriceElement.getAttribute('data-js-line-item-price'));

	const quantity = lineItemElement.querySelector('.quantity-input').value;
	const unitWeight = Number(lineItemUnitPriceElement.getAttribute('data-js-product-weight')) * quantity;
	const unitPrice = (lineItemPriceElement / unitWeight) * 1000;

	lineItemUnitPriceElement.innerText = `(${unitPrice.toFixed(2)}€/kg)`;
};

const cartDrawerElement = document.querySelector('.cart-drawer');

const mutationObserver = new MutationObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.target.classList.contains('cart-drawer') || entry.target.classList.contains('cart-drawer__inner')) {
			displayUnitPrice();
		}
	});
});

mutationObserver.observe(cartDrawerElement, {
	childList: true,
	subtree: true,
});

displayUnitPrice();
